import React from "react";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import Sidebar from "../sidebar/Sidebar";
import PageBreadcrumbs from "../layout/PageBreadcrumbs";
import { selectSidebarCollapsed } from "../../store/slices/app/appSelector";

/** Sidebar + migas + contenido: el mismo marco que el resto de pantallas. */
const ServiceBriefingPageShell: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const collapsed = useSelector(selectSidebarCollapsed);
  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      <Sidebar />
      <Box
        sx={{
          flexGrow: 1,
          p: { xs: 2, sm: 3 },
          transition: "margin-left 0.3s ease",
          marginLeft: collapsed ? "64px" : "250px",
          width: { xs: "calc(100% - 64px)", sm: "auto" },
          maxWidth: "100%",
          boxSizing: "border-box",
          overflowX: "hidden",
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          gap: 3,
        }}
      >
        <PageBreadcrumbs />
        {children}
      </Box>
    </Box>
  );
};

export default ServiceBriefingPageShell;
